import { render, staticRenderFns } from "./TodayWorkoutCard.vue?vue&type=template&id=234458b2&scoped=true"
import script from "./TodayWorkoutCard.vue?vue&type=script&lang=js"
export * from "./TodayWorkoutCard.vue?vue&type=script&lang=js"
import style0 from "./TodayWorkoutCard.vue?vue&type=style&index=0&id=234458b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234458b2",
  null
  
)

export default component.exports